module.exports = __webpack_public_path__ + "static/murachs-html5-and-css3-3ac67bfe425cb24374eb12c8227c1bfc.jpg";